import { render, staticRenderFns } from "./mvp.vue?vue&type=template&id=c67bf4be&"
import script from "./mvp.vue?vue&type=script&lang=js&"
export * from "./mvp.vue?vue&type=script&lang=js&"
import style0 from "./mvp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports